import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table, Input } from 'antd';
import { toJS, runInAction, action } from 'mobx';
import { columns, listData } from "./data"

const TextArea = Input.TextArea;

@inject('store')
@observer
class App extends Component {

    @action
    onChange = (name, value, i) => {
        let data = toJS(this.props.store.financePersonnel.data);
        data[i][name] = value;
        this.props.store.financePersonnel.data = data;
    }
    render() {
        const { data, loading } = this.props.store.financePersonnel;
        console.log(JSON.stringify(data))
        return (
            <div className="">
                {
                    listData.map((x, i) => {
                        return <div>
                            <Row className="secondary_title">{x.name}</Row>
                            {
                                [1, 2, 3].map((_, index) => {
                                    const _data = data.slice(i * 3 + index, i * 3 + index + 1)[0] || {};
                                    console.log(_data);
                                    return <div>
                                        <Table
                                            columns={columns({ sort: i * 3 + index, name: x.name, onChange: this.onChange })}
                                            dataSource={loading ? [] : [_data]}
                                            size="middle"
                                            bordered
                                            pagination={false}
                                            className="content"
                                            rowKey={(record, index) => i * 3 + index}
                                        />
                                        <Row className="note_title">{x.placeholder}</Row>
                                        {
                                            !loading &&
                                            <TextArea
                                                className="note m_b_80"
                                                autosize={{ minRows: 4 }}
                                                defaultValue={_data.notes}
                                                onBlur={e => {
                                                    runInAction(() => {
                                                        this.props.store.financePersonnel.data[i * 3 + index].notes = e.target.value || "";
                                                    })
                                                }}
                                            />
                                        }
                                    </div>
                                })
                            }

                        </div>
                    })
                }


            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/finance/personnel/Potential.js